<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>
    <v-container v-else fluid grid-list-xl px-0 py-2>
      <v-layout row wrap>
        <!-- INFO AREA -->
        <v-flex sm12 md3>
          <base-card color="secondary" class="px-3 pb-4">
            <h2 class="py-3" v-if="gallery.name">{{ gallery.name }}</h2>

            <v-img
              v-if="gallery.media"
              sizes="250px"
              :src="gallery.media.url"
              :srcset="gallery.media.srcset"
              :style="{'background-color': gallery.media.color }"
            />

            <div class="py-3">
              <h3>{{ gallery.about }}</h3>
              <p class="mt-2 pre-wrap">{{ gallery.description }}</p>
            </div>

            <ul class="pa-0 contacts">
              <li v-if="gallery.phone" class="mt-1 contact">
                <v-icon size="20">fas fa-phone-volume</v-icon>
                <span class="ml-1">{{ gallery.phone }}</span>
              </li>
              <li v-if="gallery.email" class="mt-1 contact">
                <v-icon size="18">fas fa-paper-plane</v-icon>
                <span class="ml-1">{{ gallery.email }}</span>
              </li>
              <li v-if="gallery.web_page" class="mt-1 contact">
                <v-icon size="18">fas fa-globe</v-icon>
                <a :href="gallery.web_page" :alt="gallery.web_page_label || 'gallery web page'">
                  <span class="ml-1">{{ gallery.web_page_label || gallery.web_page}}</span>
                </a>
              </li>
            </ul>

            <ul class="pa-0 mt-3 contacts">
              <li class="mt-0 contact">{{ gallery.street }}</li>
              <li class="mt-1 contact">{{ gallery.post_code }} {{ gallery.city}}</li>
            </ul>
          </base-card>
        </v-flex>

        <!-- Artworks area -->
        <v-flex sm12 md9>
          <div class="text-xs-center">
            <h2 class="headline exhibition-text">{{ artistNames }}</h2>
            <h2
              class="display-3 font-weight-light shadow my-2 exhibition-text"
            >{{gallery.exhibition_name}}</h2>
            <h2 class="headline">
              <date-range-display :from="gallery.exhibition_from" :till="gallery.exhibition_till" />
            </h2>

            <div class="my-3 pb-2">
              <p class="pre-wrap exhibition-text" v-html="descriptionProxy" />
              <tk-btn
                v-if="gallery.exhibition_description.length > 500"
                class="more-btn ml-2"
                small
                outline
                @click="descriptionExpanded = !descriptionExpanded"
              >{{ $t(descriptionExpanded ? 'COMMON.LESS' : 'COMMON.MORE') }}</tk-btn>
            </div>
          </div>

          <masonry :cols="{default: 3, 1200: 2, 960: 1}" :gutter="60">
            <tk-artwork
              v-for="artwork in gallery.artworks"
              :key="artwork.id"
              :artwork="artwork"
              class="mb-4"
            />
          </masonry>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";
import DateRangeDisplay from "@/components/base/DateRangeDisplay";

const galleriesRepo = RepositoryFactory.galleries();
const handler = new ErrorHandler();

export default {
  name: "galley-single",
  components: { DateRangeDisplay },
  props: ["gallerySlug"],
  data() {
    return {
      loading: true,
      gallery: {},
      descriptionExpanded: false
    };
  },

  computed: {
    artistNames() {
      const names = this.gallery.uniqueArtists.map(a => a.name);
      if (this.gallery.exhibition_artist) {
        names.push(this.gallery.exhibition_artist);
      }

      return names.join(", ");
    },

    descriptionProxy() {
      return !this.descriptionExpanded &&
        this.gallery.exhibition_description.length > 399
        ? this.gallery.exhibition_description.substring(0, 500) + "..."
        : this.gallery.exhibition_description;
    }
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      await handler.handle(async () => {
        this.gallery = await galleriesRepo.getGallery(this.gallerySlug);
        console.log(this.gallery);
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.contacts {
  list-style: none;
  font-size: 18px;
  line-height: 20px;

  .v-icon {
    width: 24px;
  }
}

.exhibition-text {
  color: var(--v-primary-base);
  padding-left: 100px;
  padding-right: 100px;

  @media only screen and (max-width: 600px) {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
